module.exports = __webpack_public_path__ + "static/media/431024560_434286835740002_4413696315943502896_n.873b794b.jpg";